<template>
    <v-container fluid class="px-0 py-0 tencent-video-viewer">
        <div v-if="cfg && cfg.fileId && cfg.psign">
            <video :id="playerId" style="width:100%;height:350px;" preload="auto" playsinline webkit-playsinline>
            </video>
        </div>
    </v-container>
</template>
<script>
import TCPlayer from 'tcplayer.js';
/* postcss-import-disable */
import 'tcplayer.js/dist/tcplayer.min.css';

export default {
    name: 'TencentVideoViewer',
    props: {
        cfg: Object
    },
    data() {
        return {
            fileId: null,
            psgin: null,
            playerId: `player_${Date.now()}`
        }
    },
    mounted() {
        this.init();
    },
    unmounted() {
        this.cfg = null;
    },
    watch: {
        cfg() {
            this.init();
        }
    },
    methods: {
        init() {
            let cfg = this.cfg;
            if (!cfg || !cfg.fileId || !cfg.psign) {
                return;
            }

            if (this._player) {
                //销毁一下原来的
            }
            this._player = TCPlayer(this.playerId, {
                fileID: cfg.fileId,
                appID: '1251479152',
                psign: cfg.psign
            });
        }
    }
}
</script>
